module.exports = __webpack_public_path__ + "img/3accc02.jpg";